import axios from '@/http/http.js'
import { getApiServer } from '@/config/api'
import { setStoredToken } from './session'

const USER_KEY = 'p1vp12.user'

function tokenUrl () {
  const root = (getApiServer() || '/bestbuytest').replace(/\/$/, '')
  return `${root}/DevTrackApi/token`
}

/**
 * Password grant — same contract as P1Web loginContent.vue.
 * Returns { access_token, userId, firstName, lastName, ... }
 */
export async function loginWithPassword ({ userName, password, ldapServerId = 0 }) {
  const tz = new Date().getTimezoneOffset()
  const body = {
    Grant_type: 'password',
    UserName: userName,
    Password: password,
    LDAPServerId: ldapServerId,
    IsInSessionAuth: typeof window.EnableSessionAuth !== 'undefined' ? window.EnableSessionAuth : 0
  }
  const res = await axios.post(tokenUrl(), body, {
    headers: { TimeZoneOffset: tz }
  })
  const data = res && res.data
  if (!data || !data.access_token) {
    const msg = (data && (data.error_description || data.ErrorMessage || data.message)) || 'Login failed'
    throw new Error(msg)
  }
  applyLoginSession(data)
  return data
}

export function applyLoginSession (data) {
  const token = data.access_token
  setStoredToken(token)
  try {
    sessionStorage.setItem('user_token', token)
    sessionStorage.setItem('userId', String(data.userId || ''))
    sessionStorage.setItem('userName', `${data.firstName || ''} ${data.lastName || ''}`.trim())
    sessionStorage.setItem('ShortName', data.userName || data.UserName || '')
  } catch (e) {}
  try {
    localStorage.setItem(USER_KEY, JSON.stringify({
      userId: data.userId,
      userName: `${data.firstName || ''} ${data.lastName || ''}`.trim(),
      shortName: data.userName || data.UserName || ''
    }))
  } catch (e) {}
}

export function getLoggedInUser () {
  try {
    const raw = localStorage.getItem(USER_KEY)
    if (raw) return JSON.parse(raw)
  } catch (e) {}
  const name = sessionStorage.getItem('userName')
  if (name) return { userName: name, userId: sessionStorage.getItem('userId') }
  return null
}

export function logout () {
  setStoredToken('')
  try {
    sessionStorage.removeItem('user_token')
    sessionStorage.removeItem('userId')
    sessionStorage.removeItem('userName')
    localStorage.removeItem(USER_KEY)
  } catch (e) {}
}

export function isLoggedIn () {
  return !!(sessionStorage.getItem('user_token') || localStorage.getItem('p1vp12.token'))
}
